import React from "react";
import Modal from "components/modal";
import ProductGallery from "../gallery";
import ProductDetails from "../details";

const ProductModal = ({ product, isOpen, close, hideATCPrice }) => (
	<Modal
		isOpen={isOpen}
		close={close}
		title={product.title}
	>
		<ProductGallery images={product.images} />
		<ProductDetails
			product={product}
			closeModal={close}
			hideATCPrice={hideATCPrice}
		/>
	</Modal>

);

export default ProductModal;
